import type { KioskFlowValidationError } from '../../types/kiosk-flow-types';

interface PublishValidationErrorsProps {
  errors: KioskFlowValidationError[];
}

// The backoffice's reasons the saved draft can't be published; stepIndex is 0-based
export function PublishValidationErrors({ errors }: PublishValidationErrorsProps) {
  if (errors.length === 0) return null;
  return (
    <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">
      <p className="font-medium">This flow can't be published yet:</p>
      <ul className="mt-1 list-disc space-y-0.5 pl-5">
        {errors.map((error, i) => (
          <li key={i}>{error.stepIndex != null ? `Step ${error.stepIndex + 1}: ${error.message}` : error.message}</li>
        ))}
      </ul>
    </div>
  );
}
